import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import CaseStudyParent from '@/views/CaseStudyParent.vue';
import CaseStudyIndex from '@/views/CaseStudies.vue';
import CaseStudy from '@/views/CaseStudy.vue';
import PeopleParent from '@/views/PeopleParent.vue';
import PeopleIndex from '@/views/PeopleIndex.vue';
import PeoplePerson from '@/views/PeoplePerson.vue';
import CISynchronizerEULA from '@/views/CISynchronizerEULA.vue';
import CISynchronizerSupport from '@/views/CISynchronizerSupport.vue';

import ProductParent from '@/views/products/ProductParent.vue';
import ProductIndex from '@/views/products/Products.vue';
import ProductDownload from '@/views/products/ProductDownload.vue';
import Product from '@/views/products/Product.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'homer',
      component: Home
    },
    {
      path: '/case-studies',
      name: 'case-studies',
      component: CaseStudyParent,
      children: [
        {
          path: '',
          name: 'case-study-index',
          component: CaseStudyIndex
        },
        {
          path: ':case',
          name: 'case-study',
          component: CaseStudy
        }
      ]
    },
    {
      path: '/our-people',
      name: 'our-people',
      component: PeopleParent,
      children: [
        {
          path: '',
          name: 'our-people-index',
          component: PeopleIndex
        },
        {
          path: ':person',
          name: 'people-person',
          component: PeoplePerson
        }
      ]
    },
    {
      path: '/products',
      name: 'products',
      component: ProductParent,
      children: [
        {
          path: '',
          name: 'products-index',
          component: ProductIndex
        },
        {
          path: ':product',
          name: 'product',
          component: Product
        },
        {
          path: ':product/download',
          name: 'product',
          component: ProductDownload
        }
      ]
    },
    {
      path: '/home/what-we-do',
      name: 'home-what-we-do',
      component: Home,
      props: { scrollTo: 'what-we-do' }
    },
    {
      path: '/home/who-we-are',
      name: 'home-who-we-are',
      component: Home,
      props: { scrollTo: 'who-we-are' }
    },
    {
      path: '/products/CISynchronizer/EULA',
      name: 'CISynchronizer-EULA',
      component: CISynchronizerEULA
    },
    {
      path: '/products/CISynchronizer/support',
      name: 'CISynchronizer-EULA',
      component: CISynchronizerSupport
    }
  ]
});
